import { AnchoredContent, ContentSection, Hero, Breadcrumbs, Directions, Questions, PreviewLinks } from '@/components';
import { StyledContent, StyledTitle, StyledSection } from '@/components/styles';
import { useRouter } from 'next/router';
import addSoftHyphenation from '@/lib/addSoftHyphenation';
import generateBlocks from '@/lib/generateBlocks';
import getCurrentBySlug from '@/lib/getCurrentBySlug';
import { useState } from 'react';
import vars from '@/assets/styles/vars';

export default function DirectionPage(props) {
  const { title, direction, directions, blocks, questions, recommendations, banner, short_content } = props;

  const cur = getCurrentBySlug(directions, direction.slug);
  const router = useRouter();

  const image = {
    desktop: banner?.main_page_desktop,
    tablet: banner?.main_page_tablet,
    mobile: banner?.main_page_mobile,
  };

  const directionBanner = {
    id: 1,
    title,
    image,
    theme: 'dark',
  };

  const breadcrumbs = [
    {
      id: 1,
      title: 'Home',
      slug: '',
      type: 'index',
    },
    {
      id: 2,
      title: 'OUR SERVICES',
      slug: '',
      type: 'services',
    },
    {
      id: 3,
      title: cur.title,
      slug: cur.slug,
      type: 'direction',
    },
    {
      id: 4,
      title: title,
      slug: '',
      type: 'direction',
    },
  ];

  const [thumbnailSwiper, getThumbnailSwiper] = useState(null);
  const [gallerySwiper, getGallerySwiper] = useState(null);

  const thumbnailParams = {
    getSwiper: getThumbnailSwiper,
    direction: 'horizontal',
    slidesPerView: 'auto',
    spaceBetween: 40,
    watchOverflow: true,
    watchSlidesVisibility: true,
    breakpoints: {
      [vars.breakpoints.tablet + 1]: {
        direction: 'vertical',
        spaceBetween: 20,
      },
    },
  };

  const params = {
    slidesPerView: 1,
    getSwiper: getGallerySwiper,
    preloadImages: true,
    resistanceRatio: 0,
    watchOverflow: true,
    keyboard: true,
    speed: 600,
    autoHeight: true,
    preventInteractionOnTransition: true,
    spaceBetween: 45,
    noSwipingClass: 'no-content-swiping',
    updateOnWindowResize: true,

    breakpoints: {
      [vars.breakpoints.tablet + 1]: {
        spaceBetween: 25,
      },
    },
  };

  const swiperData = { gallerySwiper, thumbnailSwiper, params, thumbnailParams };


  const handleClick = (slug) => {
    const active = directions.reduce((acc, cur) => {
      return cur.slug === slug
        ? cur
        : cur.children?.find((i) => i.slug === slug)
        ? cur.children?.find((i) => i.slug === slug)
        : acc;
    }, null);

    if (active && (active.children?.length || active.service_count > 1)) {
      router.push(
        { pathname: '/services', query: { direction: slug } },
        { pathname: '/services', query: { direction: slug } },
        { shallow: true }
      );
    } else {
      router.push({ pathname: `/${slug}`, query: {} }, { pathname: `/${slug}`, query: {} }, { shallow: true });
    }
  };

  return (
    <>
      <Hero data={[directionBanner]} size="small" />
      <StyledContent.Container>
        <StyledContent.BreadcrumbsContainer>
          {breadcrumbs?.length > 0 && <Breadcrumbs items={breadcrumbs} theme="light" />}
        </StyledContent.BreadcrumbsContainer>
      </StyledContent.Container>
      <StyledContent>
        <div style={{ overflow: 'hidden' }}>
          <StyledContent.Container>
            {!!directions?.length && <Directions directions={directions} active={cur} onClick={handleClick} />}
          </StyledContent.Container>
        </div>
        <StyledContent.Container>
          <StyledContent.Columns>
            <AnchoredContent slider singleLink={true} swiperData={swiperData}>
              <div
                type="block"
                title={blocks[0]?.data?.title || blocks[1]?.data?.title || title}
                slug={blocks[0]?.data?.slug || blocks[1]?.data?.slug || ''}
              >
                <StyledTitle StyledTitle size="large" mb="small" as="h1" black>
                  {addSoftHyphenation(title, 15)}
                </StyledTitle>
                {blocks && blocks.length > 0 && generateBlocks([blocks[0]])}
                {blocks && blocks.length > 1 && !blocks[0]?.data?.title && generateBlocks([blocks[1]])}
              </div>
              {blocks && blocks.length > 1 && blocks[0]?.data?.title && generateBlocks([blocks[1]])}
              {blocks && blocks.length > 2 && generateBlocks([...blocks].slice(2))}

              {questions && questions.length > 0 && (
                <ContentSection pt="none" type="questions">
                  <Questions data={questions} swiperData={swiperData}/>
                </ContentSection>
              )}
            </AnchoredContent>
          </StyledContent.Columns>
          {short_content && (
            <StyledSection pt='none' pb='large'>
              <StyledContent.Description>
                <StyledContent.Html dangerouslySetInnerHTML={{ __html: short_content }} dark />
              </StyledContent.Description>
            </StyledSection>
          )}
          <div></div>
        </StyledContent.Container>
        <div style={{ overflow: 'hidden' }}>
          <StyledContent.Container>
            {recommendations && recommendations.length > 0 && (
              <ContentSection pt="none" type="recommendations">
                <PreviewLinks data={recommendations} items slider />
              </ContentSection>
            )}
          </StyledContent.Container>
        </div>
      </StyledContent>
    </>
  );
}
